// Pixel position of a caret inside a <textarea>, relative to the textarea's own
// border-box top-left, ignoring its scroll offset.
//
// Browsers do not expose this directly, so this uses the standard mirror technique: copy
// every style that affects text layout onto an off-screen <div>, fill it with the text up
// to the caret, and measure where a marker <span> placed at the caret lands. Used to pin
// the "Press Tab for AI support" hint next to the cursor in the problem description.

const MIRRORED_PROPERTIES = [
  'direction',
  'boxSizing',
  'width',
  'height',
  'overflowX',
  'overflowY',
  'borderTopWidth',
  'borderRightWidth',
  'borderBottomWidth',
  'borderLeftWidth',
  'borderStyle',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
  'fontStyle',
  'fontVariant',
  'fontWeight',
  'fontStretch',
  'fontSize',
  'fontSizeAdjust',
  'lineHeight',
  'fontFamily',
  'textAlign',
  'textTransform',
  'textIndent',
  'textDecoration',
  'letterSpacing',
  'wordSpacing',
  'tabSize',
]

export const getCaretCoordinates = (textarea, position) => {
  const computed = window.getComputedStyle(textarea)
  const mirror = document.createElement('div')
  const style = mirror.style

  style.position = 'absolute'
  style.visibility = 'hidden'
  style.top = '0'
  style.left = '-9999px'
  // Textareas wrap; the mirror must too, or long lines measure as one row.
  style.whiteSpace = 'pre-wrap'
  style.wordWrap = 'break-word'
  MIRRORED_PROPERTIES.forEach((prop) => {
    style[prop] = computed[prop]
  })
  style.overflow = 'hidden'

  mirror.textContent = textarea.value.substring(0, position)
  const marker = document.createElement('span')
  // A trailing newline collapses to zero height without content after it.
  marker.textContent = textarea.value.substring(position) || '.'
  mirror.appendChild(marker)

  document.body.appendChild(mirror)
  const lineHeight = parseFloat(computed.lineHeight) || parseFloat(computed.fontSize) * 1.4
  const coords = {
    top: marker.offsetTop + parseFloat(computed.borderTopWidth || 0),
    left: marker.offsetLeft + parseFloat(computed.borderLeftWidth || 0),
    height: lineHeight,
  }
  document.body.removeChild(mirror)
  return coords
}
